import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './style.css';

ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
).render(
  <GoogleOAuthProvider clientId="521470488882-0ubnd7m3utj0em33moq39k3145eq3m28.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);

reportWebVitals();